import React from 'react'
import { useTranslation } from 'react-i18next'

import { Card } from 'primereact/card'

export const EInvoiceDisabled: React.FC = () => {
  const { t } = useTranslation('eInvoiceOverview')

  return (
    <div className="flex justify-content-center py-8">
      <Card className="w-6">
        <div className="flex flex-column align-items-center p-3">
          <span className="flex justify-content-center align-items-center bg-blue-50 border-circle w-4rem h-4rem">
            <span className="pi pi-lock text-2xl text-primary"></span>
          </span>
          <h2 className="text-xl font-bold mt-4">
            {t('eInvoiceDisabled.title')}
          </h2>
          <p className="text-center mt-0 line-height-3">
            {t('eInvoiceDisabled.description')}
          </p>
        </div>
      </Card>
    </div>
  )
}
